module.exports = __webpack_public_path__ + "static/media/insight.aad7c078.png";